module.exports = __webpack_public_path__ + "img/logo-kakao-vx-2@3x.bc71db22.png";